const PREFIX = 'SETTINGS'

export const SETTINGS_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const LOGIN_SETTINGS_GET = `LOGIN_${PREFIX}_GET`
export const CHAPTERS_GET = `CHAPTERS_GET`
export const APP_CORE_SETTINGS_GET = `${PREFIX}_GET`
export const SETTINGS_GET_ERROR = `${PREFIX}_GET_ERROR`
export const CI_CD_SETTINGS_GET = `${PREFIX}_CI_CD_GET`
export const WEB_SETTINGS_GET = `${PREFIX}_WEB_GET`
export const STYLE_SETTINGS_GET = `${PREFIX}_STYLE_GET`
export const CORE_SETTINGS_GET = `${PREFIX}_CORE_GET`
export const USER_SETTINGS_GET = `${PREFIX}_USER_GET`
export const EVENT_SETTINGS_GET = `${PREFIX}_EVENT_GET`
export const BACK_USER_SETTINGS_GET = `${PREFIX}_USER_BACK_GET`
export const SETTINGS_SECURITY_ERROR = `${PREFIX}_SECURITY_ERROR`
export const SETTINGS_URL_GET = `${PREFIX}_URL_GET`
export const SETTINGS_REGISTRATION_FIELDS_GET = `${PREFIX}_REGISTRATION_FIELDS_GET`
export const SETTINGS_REGISTRATION_FIELDS_LOADING = `${PREFIX}_REGISTRATION_FIELDS_LOADING`
export const SETTINGS_GET_LIST_FIELDS = `${PREFIX}_GET_LIST_FIELDS`
export const SETTINGS_GET_LIST_FIELDS_LOADING = `${PREFIX}_GET_LIST_FIELDS_LOADING`
export const SETTINGS_SET_DWH_DISABLED = `${PREFIX}_SET_DWH_DISABLED`
export const SETTINGS_INC_DWH_FAIL = `${PREFIX}_INC_DWH_FAIL`
export const SETTINGS_RESET_DWH_FAIL = `${PREFIX}_RESET_DWH_FAIL`

